const MaskUtil = (function () {
	const placeHolders = {
		'ru': '+7 999 999-99-99',
		'by': '+375 99 999-99-99',
		'kz': '+7 999 999 9999'
	};

	function setMask(input ,countryData) {
		const {iso2, dialCode} = countryData,
			placeholder = placeHolders[iso2],
			clearedPlaceholder = placeholder.replace(dialCode, '').replace('+ ', '').replace(/[0-9]/g, 9),
			mask = '+' + dialCode + ' ' + clearedPlaceholder;

		input.setAttribute('placeholder', placeholder);
		InputMask({'mask': mask}).mask(input);
		$(input).trigger('input');
	}

	var self = {
		initIntlTelMask: function ($field) {
			if ($field.length > 0 && typeof intlTelInput !== 'undefined') {
				const telInput = $field.get(0);

				const countries = ['by','ru','kz'],
					domain = window.elkitorg_config.current_domain;

				let initialCountry = 'ru';

				if (countries.indexOf(domain.replace('.', '')) >= 0) {
					initialCountry = domain.replace('.', '');
				}

				var iti = intlTelInput(telInput, {
					utilsScript: window.elkitorg_config.theme_path+'js/vendor/intlTelUtils.js',
					nationalMode: false,
					autoPlaceholder: 'off',
					initialCountry: initialCountry,
					onlyCountries: countries,
					localizedCountries: {
						'by': 'Беларусь', 'ru': 'Россия','kz': 'Казахстан'
					}
				});

				setMask(telInput, iti.getSelectedCountryData());

				telInput.addEventListener('countrychange', function () {
					setMask(telInput, iti.getSelectedCountryData());
				});
			}
		}
	};

	return self;
})();

export default MaskUtil;
